import './Layout.scss';

import React, { ReactNode } from 'react';

import { useAuth } from '@src/contexts/authContext';
import Footer from './Footer';
import Header from './Header';

interface IProps {
  noFooter?: boolean;
  children: ReactNode | ReactNode[];
}

function Layout({ children, noFooter }: IProps) {
  const authContext = useAuth();

  return (
    <article className="modLayout">
      <Header
        user={{
          firstName: authContext.userObject.firstName,
          lastName: authContext.userObject.lastName,
          email: '',
          phoneNumber: '',
        }}
      />
      <main className="modLayout__content">{children}</main>
      {!noFooter && <Footer />}
    </article>
  );
}

export default Layout;
